import { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '../../../utils'
import { JobCategoryBase } from '../../../types'

import { InputSearchGroupWithDropDown } from '../InputSearchGroupWithDropDown'
import { JobCategorySelectionField } from '../JobCategorySelectionField'

type Props = {
  selectedJobCategories: JobCategoryBase[]
  setFieldValue: (jobCategories: JobCategoryBase[]) => void
  placeholder?: string
}

export const JobCategorySearchField: FC<Props> = observer(
  ({ selectedJobCategories, setFieldValue, placeholder = '' }) => {
    const { companies } = useStores()
    const [isDropDownOpen, setIsDropDownOpen] = useState(false)
    const [searchResult, setSearchResult] = useState<JobCategoryBase[]>([])

    const searchResultExcludingSelected = searchResult.filter((jobCategory) => {
      const isSelected = selectedJobCategories.some((jc) => jc.slug === jobCategory.slug)
      return !isSelected
    })

    const onInputFinished = async (searchWord: string) => {
      if (companies?.jobCategories.length === 0) {
        await companies.fetchJobCategories()
      }
      const newJobCategories = filterJobCategoryByKeyword(companies.jobCategories, searchWord)
      setSearchResult(newJobCategories)
    }

    const filterJobCategoryByKeyword = (jobCategories: JobCategoryBase[], keyword: string) => {
      return jobCategories.filter((jobCategory) => {
        const name = jobCategory.name.toLowerCase()
        const slug = jobCategory.slug.toLowerCase()
        const word = keyword.toLowerCase()

        return name.includes(word) || slug.includes(word)
      })
    }

    const selectJobCategory = (jobCategory: JobCategoryBase) => {
      const isSelected = selectedJobCategories.some((jc) => jc.slug === jobCategory.slug)

      if (isSelected) {
        return
      } // 選択済みの jobCategory の場合は 何もしない

      const newJobCategories = selectedJobCategories.concat(jobCategory)
      setFieldValue(newJobCategories)
    }

    return (
      <div>
        <InputSearchGroupWithDropDown
          isDropDownOpen={isDropDownOpen}
          onInputFinished={onInputFinished}
          closeDropDown={() => setIsDropDownOpen(false)}
          openDropDown={() => setIsDropDownOpen(true)}
          placeholder={placeholder}
        >
          {isDropDownOpen && (
            <JobCategorySelectionField
              jobCategories={searchResultExcludingSelected}
              onClickOption={(jobCategory) => selectJobCategory(jobCategory)}
            />
          )}
        </InputSearchGroupWithDropDown>
      </div>
    )
  }
)
